import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { ChangeAnimation } from "@opensea/ui-kit";
import { TokenPrice } from "@/components/price/TokenPrice";
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment";
export const StatsTableRowTopOfferFragment = graphql(`
    fragment StatsTableRowTopOffer on Collection {
      topOffer {
        pricePerItem {
          token {
            unit
          }
          ...TokenPrice
        }
      }
    }
  `, [TokenPriceFragment]);
export function StatsTableRowTopOffer(t0) {
  const $ = _c(7);
  const {
    collection: key
  } = t0;
  let t1;
  if ($[0] !== key) {
    t1 = readFragment(StatsTableRowTopOfferFragment, key);
    $[0] = key;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  const t2 = collection.topOffer?.pricePerItem.token.unit;
  const t3 = collection.topOffer?.pricePerItem;
  let t4;
  if ($[2] !== t3) {
    t4 = <TokenPrice price={t3} />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== t2 || $[5] !== t4) {
    t5 = <ChangeAnimation value={t2}>{t4}</ChangeAnimation>;
    $[4] = t2;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}